import { z } from 'zod';

export const ApiMessageSchema = z.object({
  message: z.string(),
});

export type ApiResponse = z.infer<typeof ApiMessageSchema>;
